import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import { useAuthStore } from '@/stores/auth'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '', withException = '' } = router.currentRoute.value.query

  formStore.extraMap = {
    ...formStore.extraMap,
    entryPermitMSG: false,
    issuingResidencyMSG: false,
    renewResidenceMSG: false,
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true'
  }
}
const initInfo = async () => {
  const authStore = useAuthStore()
  if (authStore.user.applicationId == 2) {
    return
  }
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    setDefaultVal(res)
  }
}

const setDefaultVal = (res) => {
  const formStore = useFormStore()
  const {
    unifiedNumber = '',
    identityNumber = '',
    englishFullName = '',
    arabicFullName = '',
    nationalityId = '',
    professionId = ''
  } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    sponsorUnifiedNumber: unifiedNumber,
    sponsorIdentityNumber: identityNumber,
    sponsorEnglishName: englishFullName,
    sponsorArabicName: arabicFullName,
    sponsorNationalityId: nationalityId,
    professionId
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use187Preload error: ', error)
  }
}
